'use client';

import { useCallback, useState } from 'react';

const ZOOM_STEP = 0.1;
const ZOOM_MIN = 0.3;
const ZOOM_MAX = 4;

export function useWorkbenchZoom() {
  const [zoomMultiplier, setZoomMultiplier] = useState(1);
  const [effectiveScale, setEffectiveScale] = useState(1);

  const handleZoomIn = useCallback(
    () =>
      setZoomMultiplier((z) => Math.min(ZOOM_MAX, +(z + ZOOM_STEP).toFixed(2))),
    [],
  );

  const handleZoomOut = useCallback(
    () =>
      setZoomMultiplier((z) => Math.max(ZOOM_MIN, +(z - ZOOM_STEP).toFixed(2))),
    [],
  );

  const handleResetZoom = useCallback(() => setZoomMultiplier(1), []);

  return {
    zoomMultiplier,
    effectiveScale,
    setEffectiveScale,
    zoomPercent: Math.round(effectiveScale * 100),
    canZoomOut: zoomMultiplier > ZOOM_MIN,
    handleZoomIn,
    handleZoomOut,
    handleResetZoom,
  };
}
